/**
 * The rules for changing a cart line, without storage. The API enforces
 * them, and the cart page uses them to warn before the server has to.
 */
import { Quantity } from "../contracts/cart.js";
export const Cart = {
    /** The sentence for a product that cannot supply what is asked. */
    shortage: (stock) => (stock <= 0 ? "Sold out." : `Only ${stock} left.`),
    /** Setting a line to `quantity`, refused when the shop has fewer. */
    set: (quantity, stock) => quantity > stock ? { _tag: "Short", message: Cart.shortage(stock) } : { _tag: "Allowed", quantity },
    /** Adding `adding` to a line that holds `current`, refused past the stock or the line limit. */
    add: (current, adding, stock) => {
        const wanted = current + adding;
        if (wanted > Quantity.MAX) {
            return { _tag: "Short", message: `You can order at most ${Quantity.MAX} of one item.` };
        }
        return Cart.set(wanted, stock);
    },
    /**
     * One line from a guest cart and a user cart of the same product: the sum,
     * capped at the line limit and the stock, and never below one so the line
     * survives to show its warning.
     */
    merge: (guest, user, stock) => Math.max(Quantity.MIN, Math.min(guest + user, Quantity.MAX, stock)),
    /** One issue per line the shop cannot supply in full, keyed by product id. */
    issues: (lines) => lines.filter((line) => line.quantity > line.stock).map((line) => ({ path: line.productId, message: Cart.shortage(line.stock) })),
};
//# sourceMappingURL=cart.js.map